import React, { useEffect, useState } from "react";
import { Routes, Route, Link, Navigate } from "react-router-dom";
import "./styles.css";

function App() {
  return (
    <Routes>
      <Route path="/" element={<MainSite />} />
      {/*
        QR-LOCKED ROUTE — do not rename, remove, or change the video on it.
        A printed QR code points here (#/video, and /video via public/404.html).
        Anything printed can't be re-issued, so this path is permanent.
      */}
      <Route path="/video" element={<VideoPage />} />
      <Route path="/residue" element={<ResiduePage />} />
      <Route path="/entanglement" element={<EntanglementPage />} />
      <Route path="/book" element={<BookPage />} />
      {/* Anything unrecognised goes home instead of rendering a blank page. */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function MainSite() {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [drawingsOpen, setDrawingsOpen] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatDateTime = (date) => {
    const options = {
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };
    return date.toLocaleDateString("en-US", options);
  };

  const formatBlogDate = (date) => {
    const options = {
      month: "long",
      day: "numeric",
      year: "numeric",
    };
    return date.toLocaleDateString("en-US", options);
  };

  const drawings = [
    "EYE.PNG", "IMG_4128.jpg", "IMG_4168.jpg", "IMG_4169.JPG", "IMG_4197.JPG",
    "IMG_4233.JPG", "IMG_4248.JPG", "IMG_4283.PNG", "IMG_4292.PNG", "IMG_4293.jpg",
    "IMG_4363.JPG", "IMG_5944.PNG", "IMG_5945.jpg", "IMG_5946.jpg",
    "IMG_5947.jpg", "IMG_5948.jpg", "IMG_5949.jpg", "IMG_5950.jpg", "IMG_5952.jpg",
    "IMG_5954.jpg", "IMG_5956.jpg", "IMG_5962.PNG", "IMG_5963 2.JPG", "IMG_5963.jpg",
    "IMG_5964.jpg", "IMG_5965.jpg", "IMG_7163.JPG", "IMG_7744.jpg", "IMG_7767.jpg",
    "IMG_7769.jpg", "IMG_7770.jpg"
  ];

  const papers = [
    {
      // No pdf key — the PAPER button only renders when one is set.
      title: "Film Recommendation App",
      year: "Spring, 2026",
      link: "https://github.com/Adgonzalez2018/Film-Recommendation-App",
    },
    {
      title: "Pressure-Aware Resource Management for Resident LLM Services ",
      year: "Fall, 2025",
      link: "https://github.com/Adgonzalez2018/Resident-LLM-Services-for-Operating-Systems",
      pdf: "/papers/OS_LLM.pdf",
    },
    {
      title: "Reinforcement Learning Project",
      year: "Fall, 2025",
      link: "https://github.com/Adgonzalez2018/rob6323_go2_project",
      pdf: "/papers/RLPROJ2.pdf",
    },
    {
      title: "Jailbreaking Deep Models with Image Classification",
      year: "Spring, 2025",
      link: "https://github.com/Adgonzalez2018/DL-final-project",
      pdf: "/papers/DLPROJ3.pdf",
    },
  ];

  // Newest first.
  const blogPosts = [
    {
      title: "Timeline Update",
      date: new Date("2026-08-18T12:00:00"),
      content:
        "I've wrapped up 2 new music videos, waiting to make more to roll them out. Currently Working on a text based life simulation game called Elife, working on an ASL Recognition Model, and a stardew copilot. More to come soon",
    },
  ];

  const creativeWork = [
    {
      type: "video",
      // A vertical short: hqdefault is letterboxed to 4/3, so it sits in the
      // grid without cropping the frame the way maxresdefault would.
      title: "Noise Vignette",
      thumbnail: "https://img.youtube.com/vi/b6SPwC_Farw/hqdefault.jpg",
      link: "https://youtube.com/shorts/b6SPwC_Farw",
    },
    {
      type: "video",
      title: "Welcome To the Pearly Gates",
      thumbnail: "https://img.youtube.com/vi/wQf5BrMJPtE/maxresdefault.jpg",
      link: "https://www.youtube.com/watch?v=wQf5BrMJPtE",
    },
    {
      type: "video",
      title: "Electric Field Lines - BTS",
      thumbnail: "https://img.youtube.com/vi/_0jGNyEQvg0/maxresdefault.jpg",
      link: "https://www.youtube.com/watch?v=_0jGNyEQvg0",
    },
    {
      type: "video",
      title: "Electric Field Lines - Visualizer",
      thumbnail: "https://img.youtube.com/vi/IQDgEb3meFk/maxresdefault.jpg",
      link: "https://www.youtube.com/watch?v=IQDgEb3meFk",
    },
    {
      type: "video",
      title: "Getting Better - Beatles (Visualizer)",
      thumbnail: "https://img.youtube.com/vi/m-i2pUUVxGU/maxresdefault.jpg",
      link: "https://youtube.com/watch?v=m-i2pUUVxGU",
    },
    {
      type: "video",
      title: "You Can See Now? (Edit)",
      thumbnail: "https://img.youtube.com/vi/XDX2wK-bW6I/maxresdefault.jpg",
      link: "https://youtube.com/watch?v=XDX2wK-bW6I",
    },
  ];

  return (
    <div className="App">
      <div className="datetime-display">{formatDateTime(currentTime)}</div>
      <div className="main-content">
        <section id="home">
          <div className="section-content">
            <h1>Alex Gonzalez</h1>
            <div className="video-container">
              <iframe
                src="https://www.youtube.com/embed/XTbI3m661cM?si=cyK5xs-IDeAi7aOt"
                title="YouTube video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <p className="placeholder">
              I released this documentary in January, 2026, inspired by Chantal
              Akerman’s “News From Home” I interviewed 13 people, while
              recording the streets of New York of Summer 2025
            </p>
          </div>
        </section>

        <section id="blog">
          <div className="section-content">
            <h2>BLOG</h2>
            <div className="blog-posts">
              {blogPosts.length === 0 && (
                <p className="page-note">Nothing up right now.</p>
              )}
              {blogPosts.map((post, index) => (
                <div key={index} className="blog-post">
                  <div className="blog-post-header">
                    <h3>{post.title}</h3>
                    <p className="blog-date">{formatBlogDate(post.date)}</p>
                  </div>
                  <p className="blog-content">{post.content}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="projects-software">
          <div className="section-content">
            <h2>PROJECTS</h2>
            <h3>SOFTWARE</h3>
            <p className="placeholder">
              Machine learning research, mostly LLM evaluation and retrieval.
              Currently building an ASL recognition model and Elife, a text-based
              life simulation. Papers and code below.
            </p>

            <div className="papers-grid">
              {papers.map((paper, index) => (
                <div key={index} className="paper-card">
                  <div className="paper-content">
                    <h4>{paper.title}</h4>
                    <p className="paper-meta">{paper.year}</p>
                    <div className="paper-links">
                      <a href={paper.link} target="_blank" rel="noopener noreferrer">
                        GITHUB
                      </a>
                      {paper.pdf && (
                        <a href={paper.pdf} target="_blank" rel="noopener noreferrer">
                          PAPER
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="projects-creative">
          <div className="section-content">
            <h3>CREATIVE</h3>
            <p className="placeholder">
              I write screenplays and direct music videos.
            </p>

            <div className="creative-grid">
              {creativeWork.map((work, index) => (
                <a
                  key={index}
                  href={work.link}
                  className="creative-item"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="creative-thumbnail">
                    <img src={work.thumbnail} alt={work.title} />
                    {work.type === "video" && <div className="play-overlay">▶</div>}
                  </div>
                  <p className="creative-title">{work.title}</p>
                </a>
              ))}
            </div>

            {/* Same card as the videos above: image in a box, title beneath. */}
            <div className="creative-grid pieces-row">
              <Link className="creative-item" to="/residue">
                <div className="creative-thumbnail">
                  <img
                    src="/pieces/residue.png"
                    alt="A field of scattered letters from the residue piece"
                    loading="lazy"
                  />
                </div>
                <p className="creative-title">Residue</p>
              </Link>
              <Link className="creative-item" to="/entanglement">
                <div className="creative-thumbnail">
                  <img
                    src="/pieces/entanglement.jpg"
                    alt="A reaction diffusing across the narrative entanglement field"
                    loading="lazy"
                  />
                </div>
                <p className="creative-title">Narrative Entanglement</p>
              </Link>
              <Link className="creative-item" to="/book">
                <div className="creative-thumbnail">
                  <img
                    src="/book/book-stack.jpg"
                    alt="A stack of seven copies of the Electric Field Lines book"
                    loading="lazy"
                  />
                </div>
                <p className="creative-title">Electric Field Lines — The Book</p>
              </Link>
            </div>

            <div className="drawings-section">
              <button
                type="button"
                className="drawings-toggle"
                onClick={() => setDrawingsOpen(!drawingsOpen)}
              >
                DRAWINGS {drawingsOpen ? "▲" : "▼"}
              </button>

              {drawingsOpen && (
                <div className="drawings-grid">
                  {drawings.map((file, index) => (
                    <div key={index} className="drawing-item">
                      <img
                        src={`/drawings/${file}`}
                        alt={file.replace(/\.[^.]+$/, "")}
                        loading="lazy"
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </section>

        <section id="about">
          <div className="section-content">
            <h2>ABOUT ME</h2>
            <p className="placeholder">
              I’m Alex, an M.S. in Computer Engineering from NYU (May 2026),
              based in New York. My work sits at the intersection of machine
              learning and applied AI, focused on LLM evaluation, retrieval
              systems, and reliable AI pipelines. I’m an acknowledged
              collaborator on an M.S. thesis at NYU’s DICE Lab under Prof.
              Chinmay Hegde, researching adversarial rubric optimization and
              LLM-as-judge failure modes, and I recently shipped a full-stack
              film recommendation platform built on a hybrid RAG pipeline,
              vector search, and deterministic validation. Earlier work spans ML
              systems engineering, font classification pipelines, and an
              AI-integrated booking platform. I’m looking for roles in applied
              ML and AI engineering.
              <br />
              Outside of research I write screenplays and direct music videos. I
              released a documentary in January 2026, and have since finished
              two more music videos and designed a book for one of them.
            </p>
          </div>
        </section>
      </div>

      <div className="footer-contact">
        <p>Alex Gonzalez</p>
        <p>
            <a href="mailto:adgonzalez2023@gmail.com">
              adgonzalez2023@gmail.com
            </a>
          </p>

          <p>
            <a href="https://github.com/Adgonzalez2018/" target="_blank" rel="noopener noreferrer">
              Github
            </a>
          </p>

          <p>
            <a href="https://youtube.com/@MalexCafe" target="_blank" rel="noopener noreferrer">
              YouTube
            </a>
          </p>
      </div>
    </div>
  );
}

/**
 * Both pieces are standalone, self-contained pages — their own run loops,
 * controls, and URL parameters — served straight out of public/. Wrapping
 * either in React would only get in its way, so these pages introduce the
 * piece and hand the visitor over.
 */
function PiecePage({ title, blurb, href, repo, note }) {
  return (
    <div className="page">
      <div className="section-content">
        <Link className="page-back" to="/">
          ← BACK
        </Link>
        <h1>{title}</h1>
        <p className="placeholder">{blurb}</p>
        <div className="page-actions">
          <a className="page-action" href={href}>
            RUN IT
          </a>
          {repo && (
            <a
              className="page-action"
              href={repo}
              target="_blank"
              rel="noopener noreferrer"
            >
              GITHUB
            </a>
          )}
        </div>
        <p className="page-note">{note}</p>
      </div>
    </div>
  );
}

function ResiduePage() {
  return (
    <PiecePage
      title="RESIDUE"
      blurb="A field of words from a corpus, culled wave by wave, until the only
        thing still lit is a single statement. Every run is seeded, so a run can
        be reproduced exactly. It reads best full screen with the sound off."
      href="/residue.html"
      repo="https://github.com/Adgonzalez2018/INSY-ENTANGLEMENT"
      note={
        <>
          Press <strong>H</strong> for the HUD, <strong>space</strong> to run,
          <strong> ←→</strong> to change statement.
        </>
      }
    />
  );
}

function EntanglementPage() {
  return (
    <PiecePage
      title="NARRATIVE ENTANGLEMENT"
      blurb="A reaction diffusing across a grid, read as three layers — self,
        others, and the collective fiction. Others and collective are both
        multiplied by self: pull the self weight down and they lose the substrate
        they were painted on, and all three go with it. The collective slider
        doesn't tint anything, it bends the reaction rules, so it changes which
        patterns are reachable at all."
      href="/entanglement.html"
      note={
        <>
          Click the field to seed a new reaction. It takes about{" "}
          <strong>15 seconds</strong> to settle.
        </>
      }
    />
  );
}

/**
 * Companion page for the physical A6 book that goes with the Electric Field
 * Lines video. Copies are left around the library with a QR code on the
 * preface — that code points at the video route, not at this page, so this
 * page is free to change.
 */
function BookPage() {
  // Spread scans. Drop the images in public/book/ and list the filenames here.
  const spreads = [];

  return (
    <div className="page">
      <div className="section-content">
        <Link className="page-back" to="/">
          ← BACK
        </Link>
        <h1>ELECTRIC FIELD LINES</h1>
        <h3>THE BOOK</h3>
        <p className="placeholder">
          A6, roughly 70 pages: every photo, still, and line of text that went
          into the Electric Field Lines visualizer, laid out as a book. Copies
          are left around the library, each with a short preface and a QR code
          to the video.
        </p>

        <div className="video-container">
          <iframe
            src="https://www.youtube.com/embed/IQDgEb3meFk?rel=0"
            title="Electric Field Lines - Visualizer"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>

        {spreads.length > 0 ? (
          <div className="drawings-grid">
            {spreads.map((file, index) => (
              <div key={index} className="drawing-item">
                <img
                  src={`/book/${file}`}
                  alt={file.replace(/\.[^.]+$/, "")}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        ) : (
          <p className="page-note">Spreads going up here shortly.</p>
        )}
      </div>
    </div>
  );
}

function VideoPage() {
  return (
    <div className="video-page">
      <iframe
        src="https://www.youtube.com/embed/IQDgEb3meFk"
        title="Electric Field Lines - Visualizer"
        allowFullScreen
        style={{ border: "none" }}
      ></iframe>
      {/* Most people reach this page from the printed QR code and have no
          other way into the site, so give them one. */}
      <Link className="video-page-home" to="/">
        ALEX GONZALEZ →
      </Link>
    </div>
  );
}

export default App;